module.exports = __webpack_public_path__ + "static/media/aarush.1c236979.jpeg";